import React from 'react';
import PrintableLayout from './PrintableLayout.jsx';
import charissePicture from '../../assets/images/jenine-charisse/charisse-picture2.webp';
import cursiveNameFooter from '../../assets/images/jenine-charisse/cursive-janine-charisse-footer.webp';
import motherFatherCursiveName from '../../assets/images/jenine-charisse/mother-father-cursive-name.webp';
import palacioVenue from '../../assets/images/jenine-charisse/palacio-event-place.webp';
import dressCodeClipart from '../../assets/images/jenine-charisse/dress-code-clipart.webp';
import logicaLogo from '../../assets/images/Logica (Black and White).webp';
import { QRCodeSVG } from 'qrcode.react';
import gallery1    from '../../assets/images/jenine-charisse/charisse-gallery-1.webp';
import gallery3    from '../../assets/images/jenine-charisse/charisse-gallery-3.webp';
import gallery4    from '../../assets/images/jenine-charisse/charisse-gallery-4.webp';
import gallery5    from '../../assets/images/jenine-charisse/charisse-gallery-5.webp';
import gallery7    from '../../assets/images/jenine-charisse/charisse-gallery-7.webp';
import gallery8    from '../../assets/images/jenine-charisse/charisse-picture1.webp';
import galleryImg240 from '../../assets/images/jenine-charisse/charisse-gallery-img240.webp';
import galleryImg422 from '../../assets/images/jenine-charisse/charisse-gallery-img422.webp';
import '../../styles/JenineCharissePrintable.css';

/* ═══════════════════════════════════════════════════════════════════════
   DATA
   ═══════════════════════════════════════════════════════════════════════ */
const ROSES = [
  'Jack Luciano', 'Euan Pasajol', 'Ivan Carandang', 'Ryan Banzuela',
  'Mark Lucido', 'Gian Castillo', 'Lance Puhawan', 'Yuwin Pravin',
  'Dalziel Nave', 'Lance Balitaan', 'Aerem Manalo', 'Freddy Solis',
  'John Solis', 'Vergillio Caston', 'Argie Luciano', 'Frederick Solis',
  'Jesus Claro Nave', 'Alfred Franz Solis',
];
const CANDLES = [
  'Jennifer Claire Nave', 'Jillianne Christia Luciano', 'Jeselle Ceril Nave',
  'Jovilyn Nave', 'Armelinda Solis', 'Zenaida Aguila', 'Myrna Solis',
  'Jana Risha', 'Hana Yesha', 'Racquel Aguila', 'Jillian Garcia',
  'Liuchei Robillos', 'KC Consignado', 'Razel Nave', 'Paola Quitalig',
  'Sharmaine Bucayo', 'Marilyn Medina', 'Rehlee Diola',
];
const SHOTS = [
  'Lance Puhawan', 'Anne Kathryna Liay', 'Veronica Jimenez',
  'Allison Maxim Avila', 'Tanikka Kody Cedro', 'Janella Iglesia',
  'Lhyma Alvaran', 'Ivan Carandang', 'Erasmo Tolentino', 'Ryan Banzuela',
  'Mark Lucido', 'Albeana Cometa', 'Yanyan Prashana', 'Trojean Legaspi',
  'Benjamin Usana', 'Zean Atienza', 'Neiah Magkawas', 'Emman Malabanan',
];
const BILLS = [
  'Jillianne Christia Luciano', 'Jeselle Ceril Nave', 'Jon Aguila',
  'Helen Aguila', 'Maria Aguila', 'John Solis', 'Maan De Lima',
  'Rj Pasajol', 'Michael Guanzon', 'Jasper Nave', 'Kevin Nave',
  'Lizza Garcia', 'Beth Mercado', 'Julie Sumaoang', 'Nicolas Aguila',
  'Liza Hayashi', 'Abigail Laluz', 'Ron Arban',
];
const PROGRAM = [
  'Opening prayer',
  'Opening spill',
  'Introduction to the Family',
  'Intro video',
  'Opening production of the celebrant',
  'Growing up video',
  'Flash mob',
  'Games',
  'Opening remarks',
  'Re-Entrance',
  'Mini Cotillion',
  '18 Roses',
  "Father's speech",
  '18 Shots',
  'Intermission number',
  'Games',
  'Re-Entrance',
  '18 Bills',
  '18 Candles',
  "Mother's speech",
  'Blowing of cake / Birthday song',
  'Photo opportunity',
  'Dinner',
  'Games',
  'SDE',
  'Message of the celebrant',
  'Closing spill',
  'Grand Photo opportunity',
  'After party',
];

const TRADITION_DESC = {
  roses:   'Eighteen men who will each present a rose to the celebrant, symbolizing admiration, respect, and good wishes for her journey into womanhood.',
  candles: 'Eighteen meaningful lights from those who illuminate her path forward. Each candle carries a wish and a prayer for the birthday celebrant.',
  shots:   'Eighteen toasts from eighteen special people — each raising a glass to celebrate Jenine Charisse and wish her a life full of joy and adventure.',
  bills:   'Eighteen tokens of generosity and love, each representing the support and blessings of someone special in her life.',
};

/* ═══════════════════════════════════════════════════════════════════════
   SHARED COMPONENTS
   ═══════════════════════════════════════════════════════════════════════ */

/** Gold ornamental divider */
const Divider = () => (
  <div className="pl-divider" aria-hidden="true">
    <div className="pl-divider-line" />
    <div className="pl-divider-diamond" />
    <div className="pl-divider-line" />
  </div>
);

/** Section header used on content pages */
const SectionHeader = ({ kicker, heading }) => (
  <div style={{ textAlign: 'center', marginBottom: '4mm' }}>
    <span className="pl-section-kicker">{kicker}</span>
    <h2 className="pl-section-heading">{heading}</h2>
    <Divider />
  </div>
);

/** Tradition list column */
const TradList = ({ icon, label, desc, names }) => (
  <div className="pl-trad-panel">
    <span className="pl-trad-icon" aria-hidden="true">{icon}</span>
    <h3 className="pl-trad-heading">{label}</h3>
    <p className="pl-trad-desc">{desc}</p>
    <ul className="pl-trad-list" aria-label={`${label} participants`}>
      {names.map((name, i) => (
        <li key={i} className="pl-trad-item">
          <span className="pl-trad-num">{i + 1}.</span>
          {name}
        </li>
      ))}
    </ul>
  </div>
);

/* ═══════════════════════════════════════════════════════════════════════
   MAIN COMPONENT
   ═══════════════════════════════════════════════════════════════════════ */
export default function JenineCharissePrintable() {
  return (
    <PrintableLayout
      title="Jenine Charisse — Printable Invitation (12 pages)"
      filename="jenine-charisse-invitation"
    >

      {/* ══════════════════════════════════════════════════════════
          PAGE 1 — COVER
          ══════════════════════════════════════════════════════════ */}
      <article
        className="pl-page pl-cover"
        aria-label="Cover page"
        style={{ backgroundImage: `url(${charissePicture})` }}
      >
        {/* Dark gradient overlay */}
        <div className="pl-cover-overlay" aria-hidden="true" />
        {/* Gold border frame */}
        <div className="pl-cover-frame" aria-hidden="true" />
        {/* Text pinned to bottom */}
        <div className="pl-cover-text">
          <span className="pl-cover-invite-tag">You are cordially invited to celebrate</span>
          <h1 className="pl-cover-hero-name">Jenine Charisse</h1>
          <p className="pl-cover-hero-turns">Turns Eighteen</p>
          <p className="pl-cover-hero-theme">✦ &ensp; An Enchanted Garden Birthday &ensp; ✦</p>
          <div className="pl-cover-hero-divider" aria-hidden="true">
            <div className="pl-cover-hero-divider-line" />
            <div className="pl-cover-hero-divider-diamond" />
            <div className="pl-cover-hero-divider-line" />
          </div>
          <p className="pl-cover-hero-meta">Sunday &nbsp;·&nbsp; May 24, 2026 &nbsp;·&nbsp; 4:00 PM</p>
          <p className="pl-cover-hero-venue">Palacio's Event Place</p>
          <p className="pl-cover-hero-hosted">
            Hosted with love by Alfred Franz &ensp;✧&ensp; Jennifer Claire
          </p>
        </div>
      </article>

      {/* ══════════════════════════════════════════════════════════
          PAGE 2 — WELCOME MESSAGE & CELEBRATION DETAILS
          ══════════════════════════════════════════════════════════ */}
      <article className="pl-page" aria-label="Welcome and details">
        <div className="pl-content">
          <SectionHeader kicker="A message from the heart" heading="Dear Beloved Guests," />

          <p className="pl-body-text">
            With hearts full of joy and gratitude, we invite you to witness a once-in-a-lifetime milestone —
            the blossoming of a remarkable young woman into all she is beautifully meant to be.
          </p>
          <p className="pl-body-text">
            <strong>Jenine Charisse</strong> is turning eighteen, and on this enchanted afternoon, we celebrate
            not merely a birthday, but the beginning of a radiant new chapter — a story written in grace,
            in laughter, and in love that will last a lifetime.
          </p>

          <div className="pl-body-quote">
            "She blooms in the most enchanted garden,<br />
            and the whole world lights up around her."
          </div>

          <p className="pl-body-text">
            You have been chosen to be part of this magical afternoon — not merely as a witness,
            but as a cherished soul whose warmth, prayers, and well-wishes mean everything
            to her and to our family.
          </p>

          <p className="pl-body-text" style={{ textAlign: 'center', marginTop: '2mm' }}>
            With all our love,
          </p>
          <img src={motherFatherCursiveName} alt="Alfred Franz & Jennifer Claire" className="pl-signature-img" />

          {/* Celebration Details */}
          <div className="pl-details-box">
            <h3 className="pl-details-box-title">✦ &ensp; Celebration Details &ensp; ✦</h3>
            <div className="pl-details-grid">
              <div>
                <span className="pl-detail-label">Date</span>
                <span className="pl-detail-value">Sunday, May 24, 2026</span>
              </div>
              <div>
                <span className="pl-detail-label">Time</span>
                <span className="pl-detail-value">4:00 PM</span>
              </div>
              <div>
                <span className="pl-detail-label">Venue</span>
                <span className="pl-detail-value">Palacio's Event Place</span>
              </div>
              <div>
                <span className="pl-detail-label">Theme</span>
                <span className="pl-detail-value">Enchanted Garden</span>
              </div>
            </div>
            <div className="pl-family-row">
              <div className="pl-family-person">
                <span className="pl-family-role">Father</span>
                <span className="pl-family-name">Alfred Franz</span>
              </div>
              <span className="pl-family-sep" aria-hidden="true">✧</span>
              <div className="pl-family-person">
                <span className="pl-family-role">Mother</span>
                <span className="pl-family-name">Jennifer Claire</span>
              </div>
            </div>
          </div>
        </div>
      </article>

      {/* ══════════════════════════════════════════════════════════
          PAGE 3 — GLIMPSE OF THE CELEBRANT
          ══════════════════════════════════════════════════════════ */}
      <article className="pl-page" aria-label="Glimpse of the celebrant">
        <div className="pl-content">
          <SectionHeader kicker="A glimpse of the celebrant" heading="Jenine Charisse" />
          <div className="pl-photogallery-grid">
            <div className="pl-photogallery-cell pl-gallery-cell--first"><div className="pl-photo-bg" style={{ backgroundImage: `url(${gallery1})` }} /></div>
            <div className="pl-photogallery-cell"><div className="pl-photo-bg" style={{ backgroundImage: `url(${gallery3})` }} /></div>
            <div className="pl-photogallery-cell"><div className="pl-photo-bg" style={{ backgroundImage: `url(${galleryImg422})` }} /></div>
            <div className="pl-photogallery-cell"><div className="pl-photo-bg" style={{ backgroundImage: `url(${gallery8})` }} /></div>
          </div>
        </div>
      </article>

      {/* ══════════════════════════════════════════════════════════
          PAGE 4 — DRESS CODE & GUEST INSTRUCTIONS
          ══════════════════════════════════════════════════════════ */}
      <article className="pl-page" aria-label="Dress code and guest instructions">
        <div className="pl-content">
          <SectionHeader kicker="Everything you need to know" heading="Dress Code & Guest Reminders" />

          <div className="pl-two-col" style={{ flex: 1 }}>

            {/* Left: Dress Code */}
            <div className="pl-panel">
              <span className="pl-panel-kicker">Dress for the enchanted garden</span>
              <h3 className="pl-panel-heading">Dress Code</h3>
              <Divider />
              <img src={dressCodeClipart} alt="Semi-formal attire" className="pl-dresscode-img" />
              <p className="pl-dresscode-body">
                Guests are warmly invited to dress in semi-formal wear. Embrace the beauty of the
                occasion with elegance and style.
              </p>
              <p className="pl-dresscode-body">
                <strong>Please do not wear red or silver attire</strong> — any other color is perfectly welcome.
              </p>
              <div className="pl-pills">
                <span className="pl-pill pl-pill-ladies">👸 Ladies — Semi-Formal Dress</span>
                <span className="pl-pill pl-pill-gents">🤵 Gentlemen — Semi-Formal</span>
                <span className="pl-pill pl-pill-avoid">🚫 Avoid — Red &amp; Silver</span>
              </div>
            </div>

            {/* Right: Guest Instructions */}
            <div className="pl-panel">
              <span className="pl-panel-kicker">A kind request from the family</span>
              <h3 className="pl-panel-heading">Special Instructions</h3>
              <Divider />
              <ul className="pl-instr-list">
                <li className="pl-instr-item">
                  <span className="pl-instr-num">1</span>
                  <p className="pl-instr-text">
                    <strong>Upon arrival</strong> — A coordinator will assist you at the entrance and
                    provide your table number. Please be seated once you receive it. A grazing table,
                    mobile bar, and photobooth will be available throughout the evening.
                  </p>
                </li>
                <li className="pl-instr-item">
                  <span className="pl-instr-num">2</span>
                  <p className="pl-instr-text">
                    <strong>Drop a letter</strong> — Bring a handwritten letter to drop in the box at
                    the coordinator's table. The celebrant will treasure every message she receives.
                  </p>
                </li>
                <li className="pl-instr-item">
                  <span className="pl-instr-num">3</span>
                  <p className="pl-instr-text">
                    <strong>18 Candles, 18 Shots &amp; 18 Bills participants</strong> — Please prepare a
                    short birthday message. Write it in a letter, read it to her when your name is called,
                    then place it in the letter box.
                  </p>
                </li>
                <li className="pl-instr-item">
                  <span className="pl-instr-num">4</span>
                  <p className="pl-instr-text">
                    <strong>Share the memories</strong> — Take as many photos and videos as you like!
                    Please send them to the Facebook account <strong>"Claire Nave."</strong>
                  </p>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </article>

      {/* ══════════════════════════════════════════════════════════
          PAGE 5 — 18 ROSES & 18 CANDLES
          ══════════════════════════════════════════════════════════ */}
      <article className="pl-page" aria-label="18 Roses and 18 Candles">
        <div className="pl-content">
          <SectionHeader kicker="A birthday full of tradition" heading="Special Traditions — Part 1" />
          <div className="pl-trad-cols">
            <TradList icon="🌹" label="18 Roses" desc={TRADITION_DESC.roses} names={ROSES} />
            <TradList icon="🕯️" label="18 Candles" desc={TRADITION_DESC.candles} names={CANDLES} />
          </div>
        </div>
      </article>

      {/* ══════════════════════════════════════════════════════════
          PAGE 6 — 18 SHOTS & 18 BILLS
          ══════════════════════════════════════════════════════════ */}
      <article className="pl-page" aria-label="18 Shots and 18 Bills">
        <div className="pl-content">
          <SectionHeader kicker="A birthday full of tradition" heading="Special Traditions — Part 2" />
          <div className="pl-trad-cols">
            <TradList icon="🥂" label="18 Shots" desc={TRADITION_DESC.shots} names={SHOTS} />
            <TradList icon="💵" label="18 Bills" desc={TRADITION_DESC.bills} names={BILLS} />
          </div>
        </div>
      </article>

      {/* ══════════════════════════════════════════════════════════
          PAGE 7 — PROGRAM FLOW
          ══════════════════════════════════════════════════════════ */}
      <article className="pl-page pl-program-bg" aria-label="Program flow">
        <div className="pl-content">
          <SectionHeader kicker="The evening's schedule" heading="Program Flow" />
          <div className="pl-program-card">
            <ol className="pl-program-list">
              {PROGRAM.map((item, i) => (
                <li key={i} className="pl-program-item">
                  <span className="pl-program-num">{i + 1}.</span>
                  <span>{item}</span>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </article>

      {/* ══════════════════════════════════════════════════════════
          PAGE 8 — VENUE, GIFT GUIDE & CLOSING
          ══════════════════════════════════════════════════════════ */}
      <article className="pl-page" aria-label="Venue, gift guide, and closing">
        <div className="pl-content">
          <SectionHeader kicker="Find your way to the celebration" heading="The Venue" />

          <img src={palacioVenue} alt="Palacio's Event Place" className="pl-venue-photo" />
          <h3 className="pl-venue-name">Palacio's Event Place</h3>
          <p className="pl-venue-meta">maps.app.goo.gl/A9QeSnZuGadjH2PT6</p>
          <p className="pl-venue-note">✦ &ensp; Ample parking is available for all guests</p>

          <Divider />

          <div style={{ textAlign: 'center', marginBottom: '2mm' }}>
            <span className="pl-section-kicker">A note from the celebrant</span>
            <h3 className="pl-section-heading" style={{ fontSize: '13pt' }}>Gift Guide</h3>
          </div>

          <div className="pl-gift-quote">
            "Your presence at my birthday party is the best birthday gift I could ask for!
            If you feel comfortable giving more, a contribution to my <strong>Travel Fund</strong> would be
            greatly appreciated."
          </div>
          <p className="pl-gift-sig">— Jenine Charisse</p>

          <div className="pl-closing">
            <span className="pl-closing-tag">✦ &ensp; See you at the garden &ensp; ✦</span>
            <img src={cursiveNameFooter} alt="Jenine Charisse" className="pl-closing-cursive" />
            <p className="pl-closing-text">Sunday · May 24, 2026 · 4:00 PM · Palacio's Event Place</p>
          </div>

        </div>
      </article>

      {/* ══════════════════════════════════════════════════════════
          PAGE 9 — PHOTO GALLERY PART 1 (2 images)
          ══════════════════════════════════════════════════════════ */}
      <article className="pl-page" aria-label="Photo gallery part 1">
        <div className="pl-content">
          <SectionHeader kicker="More moments to cherish" heading="Photo Gallery" />
          <div className="pl-photogallery-2up">
            <div className="pl-photogallery-cell pl-gallery2-cell--first"><div className="pl-photo-bg" style={{ backgroundImage: `url(${gallery4})` }} /></div>
            <div className="pl-photogallery-cell"><div className="pl-photo-bg" style={{ backgroundImage: `url(${gallery5})` }} /></div>
          </div>
        </div>
      </article>

      {/* ══════════════════════════════════════════════════════════
          PAGE 10 — PHOTO GALLERY PART 2 (2 images)
          ══════════════════════════════════════════════════════════ */}
      <article className="pl-page" aria-label="Photo gallery part 2">
        <div className="pl-content">
          <SectionHeader kicker="More moments to cherish" heading="Photo Gallery" />
          <div className="pl-photogallery-2up pl-photogallery-2up--side-by-side">
            <div className="pl-photogallery-cell pl-gallery-p2-cell--first"><div className="pl-photo-bg" style={{ backgroundImage: `url(${galleryImg240})` }} /></div>
            <div className="pl-photogallery-cell pl-gallery-p2-cell--second"><div className="pl-photo-bg" style={{ backgroundImage: `url(${gallery7})` }} /></div>
          </div>
        </div>
      </article>

      {/* ══════════════════════════════════════════════════════════
          PAGE 11 — QR CODE / RSVP
          ══════════════════════════════════════════════════════════ */}
      <article className="pl-page pl-qr-page" aria-label="RSVP QR Code">
        <div className="pl-qr-inner">
          <span className="pl-qr-kicker">You’re invited</span>
          <h2 className="pl-qr-heading">Scan to View the Digital Invitation</h2>
          <div className="pl-qr-divider" aria-hidden="true">
            <div className="pl-qr-divider-line" />
            <div className="pl-qr-divider-diamond" />
            <div className="pl-qr-divider-line" />
          </div>
          <div className="pl-qr-code-wrap">
            <QRCodeSVG
              value="https://e-invitation.online/debut/jenine-charisse"
              size={160}
              bgColor="transparent"
              fgColor="#3a2c22"
              level="M"
            />
          </div>
          <p className="pl-qr-url">e-invitation.online/debut/jenine-charisse</p>
          <p className="pl-qr-desc">
            Scan the QR code to open the interactive invitation. You can submit your RSVP,
            view event details, and check your seat reservation directly from your phone.
          </p>
        </div>
      </article>

      {/* ══════════════════════════════════════════════════════════
          PAGE 12 — THANK YOU / CLOSING (mirrors digital footer)
          ══════════════════════════════════════════════════════════ */}
      <article className="pl-page pl-thankyou-page" aria-label="Thank you and closing">
        <div className="pl-thankyou-inner">
          <img src={cursiveNameFooter} alt="Jenine Charisse" className="pl-thankyou-script" />
          <p className="pl-thankyou-turns">Turns Eighteen &nbsp;·&nbsp; May 24, 2026</p>
          <p className="pl-thankyou-message">
            Thank you for being one of the cherished souls invited to witness this
            enchanted celebration. Your love, your laughter, and your presence mean
            everything to us. We cannot wait to celebrate with you.
          </p>
          <hr className="pl-thankyou-divider" aria-hidden="true" />
          <p className="pl-thankyou-credit">✦ &nbsp; An Enchanted Garden Birthday</p>
          <div className="pl-thankyou-watermark">
            <p>Created with ❤️ by</p>
            <img src={logicaLogo} alt="Logica Technology" className="pl-thankyou-logo" />
          </div>
        </div>
      </article>

    </PrintableLayout>
  );
}
